import React, { lazy, Suspense } from 'react';

const LazyUserIdDetail = lazy(() => import('./UserIdDetail'));

const UserIdDetail = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode },
) => (
  <Suspense fallback={null}>
    <LazyUserIdDetail {...props} />
  </Suspense>
);

export default UserIdDetail;
